import { Image, View, Text } from "react-native";
import { style_templates } from "../config_variables/styles";
import Icon2 from "react-native-vector-icons/FontAwesome";
import images  from '../utils/images';

const Screen1Card = (props) => {

      return (
            <View key={props.key} style={style_templates.screen1_container_box}>
                  
                  {/* <View style={style_templates.tranche_number_box_lot}> */}
                   <View style={style_templates.screen1_container_box_icon}>
                        <Image
                              source={images[props.name] ? images[props.name] : ""}
                              style={style_templates.ImageIconStyle}
                        />
                  </View>
                  {/* <View style={style_templates.screen1_container_box_icon}>
                        <View style = {[style_templates.screen_circle_icon, {backgroundColor: props.color}]}>
                              <Icon2 name={props.icon} size={20} color="white" />
                        </View>
                  </View> */}
                  <View style={style_templates.screen1_container_box_count_and_text}>
                        <View style={style_templates.screen1_container_box_count}>
                              <Text style={style_templates.dashboard_text_value}>
                                    {props.count}
                              </Text>
                        </View>
                        <View style={style_templates.screen1_container_box_text}>
                              <Text style={style_templates.screen1_desriptive_text}>
                                    {props.name}
                              </Text>
                        </View>                                                                  
                  </View>
            </View>
      )
}
      
export default Screen1Card
